import React, { useState } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { useSport } from "../../../../context/SportContext.tsx";
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowSortedDown } from "react-icons/ti";
import { Schedule } from "../../../../models/Schedule.tsx";
import { MobileColumnTab } from "./mobileMarketColumns.ts";

type ITableComponents = {
    game: Schedule;
    mobileColumnTab?: MobileColumnTab;
    onSpreadTabClick?: () => void;
    onTotalTabClick?: () => void;
    onToggleColumns?: (event: React.MouseEvent<HTMLDivElement>) => void;
    showLeagueBanner?: boolean;
    showColumnHeaders?: boolean;
}

export function TableComponents(props: ITableComponents) {
    const {
        game,
        mobileColumnTab = 'spread',
        onSpreadTabClick,
        onTotalTabClick,
        onToggleColumns,
        showLeagueBanner = true,
        showColumnHeaders = true,
    } = props;
    const useReactColumnToggle = Boolean(onSpreadTabClick && onTotalTabClick);

    const { refreshSelectedGames } = useSport();
    const [isRotating, setIsRotating] = useState(false);

    const handleClick = () => {
        setIsRotating(true);
        refreshSelectedGames()
    };

    const leagueName = game?.league?.name;
    const isMlb = leagueName?.toUpperCase() === "MLB";
    const fullMarketTitle = game.odds?.[0]?.market || "";

    const marketTitle = fullMarketTitle.split(" ").slice(0, 2).join(" ").toLowerCase();

    const shouldShowMarketTitle = marketTitle.includes("half") || marketTitle.includes("quarter") || marketTitle.includes("period");
    let displayTitle = marketTitle;

    if (isMlb && marketTitle === "1st half") {
        displayTitle = "1st 5";
    }

    return (
        <div className={`schedule-table${!showLeagueBanner ? ' schedule-table--columns-only' : ''}${!showColumnHeaders ? ' schedule-table--banner-only' : ''}`}>
            {showLeagueBanner && (
                <div className='container-table-bets'>
                    {/* <div style={{ position: "relative", display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
                        <ImageWithPlaceholder src={game.leagueLogo} className="league-logo-table" alt="" />
                    </div> */}
                    <span className='market-title teko'>{game.league.name} </span>
                    {shouldShowMarketTitle && (
                        <div className="market-title teko">
                            {displayTitle}
                        </div>
                    )}
                </div>
            )}

            {showColumnHeaders && (
                <div className="d-flex align-items-center color-title">
                    <div className="team-name-container">
                        <button className="refresh-button d-lg-none" onClick={handleClick}>
                            <HiOutlineRefresh className={`refresh-icon ${isRotating ? "rotate" : ""}`} />
                            <span className="refresh">REFRESH</span>
                        </button>
                    </div>

                    <div
                        className={`spread-container ${useReactColumnToggle && mobileColumnTab === 'teamTotal' ? 'd-none d-lg-block' : ''}`}
                        {...(useReactColumnToggle
                            ? { onClick: onSpreadTabClick }
                            : { 'data-toggle': '.market-0', 'data-pair': '.market-1', onClick: onToggleColumns }
                        )}
                    >
                        <span className="title-with-arrows">
                            <span className="title-table-game d-none d-lg-block">SPREAD</span>
                            <span className="title-table-game d-lg-none">SPREAD / ML</span>
                            <span className="arrow-icons">
                                <TiArrowSortedUp className="arrow-up" />
                                <TiArrowSortedDown className="arrow-down" />
                            </span>
                        </span>
                    </div>
                    <div className="moneyline-container d-none d-lg-block">
                        <span className="title-table-game d-none d-lg-block">MONEYLINE</span>
                    </div>
                    <div
                        className="total-container"
                        {...(useReactColumnToggle
                            ? { onClick: onTotalTabClick }
                            : { 'data-toggle': '.market-3', 'data-default': '.market-0, .market-2', 'data-is-full': true, onClick: onToggleColumns }
                        )}
                    >
                        <span className="title-with-arrows">
                            <span className="title-table-game d-none d-lg-block">TOTAL</span>
                            <span className="title-table-game d-lg-none">TOTAL/TT</span>
                            <span className="arrow-icons">
                                <TiArrowSortedUp className="arrow-up" />
                                <TiArrowSortedDown className="arrow-down" />
                            </span>
                        </span>
                    </div>
                    <div className="over-under-container d-none d-lg-block">
                        <span className="title-table-game">TEAM TOTAL</span>
                    </div>
                </div>
            )}
        </div>
    );

}
